import NextLink from 'next/link'
import type { ComponentProps } from 'react'

type LinkProps = Omit<ComponentProps<typeof NextLink>, 'href'> & { href: string }

/**
 * Site-wide internal link. Always prefetches its route — every public page
 * is statically prerendered, so payloads are small and forever-cacheable.
 * Centralised so link behaviour (analytics, transitions, prefetch policy)
 * can evolve in one place. Use `<a>` for anchors, downloads, external URLs.
 */
export function Link({ href, ...props }: LinkProps) {
  return <NextLink href={href} prefetch {...props} />
}
